// import React from "react";
// import { HashRouter as Router, Routes, Route } from "react-router-dom";
// import Navbar from "./Navbar";
// import Tabs from "./Tabs";
// import News from "./Completed_Talkshow.jsx";
// import GetStarted from "./GetStarted";
// import "../index.css";
// import '../GetStarted.css';
// import "../Completed_Talkshow.css"

// function App() {
//   return (
//     <Router>
//       <div>
//         <Navbar />
//         <Tabs/>
//         <Routes>
//           <Route path="/" element={<GetStarted />} />
//           <Route path="/news" element={<News />} />
//           <Route path="/news/:sectionId" element={<News />} /> 
//           <Route path="/upcoming" element={<GetStarted />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;
import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Navbar from "../components/Navbar.jsx";
import Tabs from "../pages/Tabs.jsx";
import Completed from "../pages/Completed_Talkshow.jsx";
import GetStarted from "../pages/GetStarted.jsx";
import "../index.css";
import '../styles/GetStarted.css';
import CreateAccount from "../components/Create_Account.jsx";
import Login from "../admin/Login.jsx";
import '../styles/Create_Account.css';
import "../styles/admin/Login.css";
import "../styles/admin/Admin_Panel.css";
import AdminPanel from "../admin/Admin_Panel.jsx";
// import '../styles/Add_Article.css';
// import AddArticle from "./Add_Article.jsx";
import '../styles/Home.css';
import Home from "../pages/Home.jsx";
import '../styles/Footer.css';
import Footer from "../components/Footer.jsx";
//import "./Completed_Talkshow.css"
import ReadMore from "../pages/Read_More.jsx";
import '../styles/Read_More.css';
import '../styles/Search_Results.css';
import SearchResults from "../pages/Search_Results.jsx";
import ChatBot from "../pages/ChatBot.jsx";
import '../styles/ChatBot.css';
import Subscribe from "../pages/subscribe.jsx";
import "../styles/subscribe.css";
import UserLogin from "../components/User_Login.jsx";
import "../styles/User_Login.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import About from "../pages/About.jsx";
import '../styles/About.css';
import Topics from "../pages/Topics.jsx";
import MyShows from "../pages/MyShows.jsx";
import '../styles/MyShows.css';


function App() {
  return (
    <HashRouter>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<Completed />} />
          <Route path="/news/:sectionId" element={<Completed />} /> 
          <Route path="/upcoming" element={<GetStarted />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/login" element={<Login/>}/> 
          <Route path="/admin-panel" element={<AdminPanel/>}/>
          {/* <Route path="/add-article" element={<AddArticle/>}/>  */}
          <Route path="/myshows" element={<MyShows/>}/>
          <Route path="/home" element={<Home/>}/>
          <Route path="/read-more" element={<ReadMore/>}/>
          {/* <Route path="/readmore/:id" element={<ReadMore />} /> */}
          <Route path="/read-more/:id" element={<ReadMore />} />
          <Route path="/search-results" element={<SearchResults />} />
          <Route path="/chat-bot" element={<ChatBot />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/topics" element={<Topics />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;